<template>
  <div class="announcement-wrapper">

    <div class="overlay"></div>

    <div class="announcement">

      <button class="close-button" type="button" @click="closed">

        <svg fill="#666666" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
             x="0px" y="0px" viewBox="0 0 96 96"
             enable-background="new 0 0 96 96" xml:space="preserve">

          <polygon points="96,14 82,0 48,34 14,0
                   0,14 34,48 0,82 14,96 48,62 82,96 96,82 62,48">
          </polygon>

        </svg>

      </button>

      <div class="scroll-layer">

        <announcement-markdown/>

      </div>
    </div>

  </div>
</template>

<script>
import AnnouncementMarkdown from '../../../../../../Announcement.md';

export default {
  name: 'ModalAnnouncement',
  components: {
    AnnouncementMarkdown,
  },
  methods: {
    closed() {
      this.$modal.clearComponent();
    },
  },
};
</script>

<style lang="scss" scoped>
.announcement-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  align-items: center;

  width: 100vw;
  height: 100%;

  .overlay {
    position: fixed;
    overflow: hidden;

    left: 0;
    top: 0;

    width: 100%;
    height: 100%;

    background-color: rgba(0, 0, 0, 0.2);
  }

  .announcement {
    position: relative;

    width: 90%;
    height: 90%;

    background-color: rgb(255, 255, 255);
    border-radius: 15px;

    .close-button {
      position: absolute;
      right: 10px;
      top: 10px;

      z-index: 10001;

      width: 3em;
      height: 3em;

      border: none;
      outline: none;
      background: transparent;

      -webkit-tap-highlight-color: transparent;
    }

    .scroll-layer {
      width: 100%;
      height: 100%;

      -webkit-overflow-scrolling: touch;

      overflow-y: scroll;
      padding: 50px;
    }
  }
}

@media screen and (max-width: 1024px) {
  .announcement-wrapper {
    margin-top: 60px;
    justify-content: flex-start;

    .announcement {
      width: 100%;
      height: 80%;

      .scroll-layer {
        padding-left: 15px;
        padding-right: 15px;

        padding-bottom: 200px;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/spa/components/modal/board-modal/ModalAnnouncement.vue